webpackJsonp([172619500505874],{

/***/ 326:
/***/ (function(module, exports) {

	module.exports = {"titleSpan":[{"titlePartial":"Progress"},{"titlePartial":"Tracker"}],"subtitle":"Major companies around the world are changing the way chickens are treated.","p1":"Consumer boycotts and industry pressure are making higher animal welfare the new standard. This commitment tracker is a resource for the public to monitor animal welfare progress of corporations around the world.","p2":"Help us track this global momentum -","link1Text":"submit additional animal welfare policies and progress reports!","link1Address":"https://form.asana.com/?k=BlEvtx70gKx1V2H_TVBJKg&d=104221056738874","p3":["Spot an error? Please","or email"],"link2Text":"submit an error report","link2Address":"https://goo.gl/forms/2wt8FFmoqPyyEHG12","email":"track@chickenwatch.org"}

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var renderTable = exports.renderTable = function renderTable() {
	  window.AwesomeTableViewInclude = {};var e = document.querySelectorAll('div[data-type="AwesomeTableView"]');document.head.insertAdjacentHTML("beforeend", '<style>iframe[data-type="AwesomeTableView"]{width:100%;height:600px;border:none;}</style>');for (var t = 0; t < e.length; t++) {
	    !function (e) {
	      var t = new Date().getTime().toString() + Math.round(100 * Math.random()).toString(),
	          o = e.getAttribute("data-viewID");e.insertAdjacentHTML("afterend", '<iframe data-type="AwesomeTableView" name="' + t + '" src="https://view-awesome-table.com/' + o + '/view" scrolling="no"></iframe>');var n = e.nextSibling;e.parentNode.removeChild(e), e = null, window.addEventListener("message", function (e) {
	        "https://view-awesome-table.com" != e.origin && e.origin != document.location.origin || "object" == typeof e.data && "ref" in e.data && e.data.ref === t && "AWTheight" in e.data && n.setAttribute("style", "height:" + e.data.AWTheight + "px;");
	        var spinner = document.querySelector('[data-idf="loading-spinner"]');
	        spinner.parentNode.removeChild(spinner);
	      }, !1);
	    }(e[t]);
	  }e = null;
	};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blocks = __webpack_require__(15);
	
	var _elements = __webpack_require__(7);
	
	var _tracker = __webpack_require__(326);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _utilities = __webpack_require__(3);
	
	var _awesomeTable = __webpack_require__(182);
	
	var _renderTitleSpan = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressTracker = function (_Component) {
	    _inherits(ProgressTracker, _Component);
	
	    function ProgressTracker() {
	        _classCallCheck(this, ProgressTracker);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ProgressTracker.prototype.componentDidMount = function componentDidMount() {
	        (0, _awesomeTable.renderTable)();
	    };
	
	    ProgressTracker.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            this.renderMain(),
	            this.renderTable()
	        );
	    };
	
	    //
	    // Partials
	    //
	
	    ProgressTracker.prototype.renderMain = function renderMain() {
	        return _react2.default.createElement(
	            _blocks.StyledSection,
	            { background: (0, _utilities.fromThemeProps)("offWhite") },
	            _react2.default.createElement(
	                _blocks.StyledRow,
	                { paddingTop: (0, _utilities.fromThemeProps)("headerHeight") },
	                _react2.default.createElement(
	                    _blocks.StyledColumn,
	                    { background: "none", paddingTop: "1.5em" },
	                    (0, _renderTitleSpan.renderTitleSpan)(_tracker2.default, "alt"),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                        _elements.H3,
	                        null,
	                        _tracker2.default.subtitle
	                    )
	                )
	            )
	        );
	    };
	
	    ProgressTracker.prototype.renderTable = function renderTable() {
	        return _react2.default.createElement(
	            _blocks.StyledSection,
	            null,
	            _react2.default.createElement(
	                "div",
	                { style: { marginTop: "3em", maxWidth: "60em", width: "90%", position: "relative", paddingTop: "20px" } },
	                _react2.default.createElement(_elements.AwesomeLoading, { "data-idf": "loading-spinner" }),
	                _react2.default.createElement("div", { "data-type": "AwesomeTableView", "data-viewID": "-NqYH6wXir1Ia4I27P6G" })
	            ),
	            _react2.default.createElement(
	                _blocks.StyledRow,
	                null,
	                _react2.default.createElement(
	                    _blocks.StyledColumn,
	                    null,
	                    _react2.default.createElement(
	                        _elements.P,
	                        null,
	                        _tracker2.default.p1
	                    ),
	                    _react2.default.createElement("hr", { style: { width: "100%" } }),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                        _elements.P,
	                        null,
	                        _tracker2.default.p2,
	                        " ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(
	                                _elements.A,
	                                { href: _tracker2.default.link1Address, target: "_blank" },
	                                _tracker2.default.link1Text
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _elements.P,
	                        null,
	                        _tracker2.default.p3[0],
	                        " ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(
	                                _elements.A,
	                                { href: _tracker2.default.link2Address, target: "_blank" },
	                                _tracker2.default.link2Text
	                            )
	                        ),
	                        " ",
	                        _tracker2.default.p3[1],
	                        " ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _react2.default.createElement(
	                                _elements.A,
	                                { href: "mailto:" + _tracker2.default.email },
	                                _tracker2.default.email
	                            ),
	                            "."
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return ProgressTracker;
	}(_react.Component);
	
	exports.default = ProgressTracker;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-progress-tracker-js-8f7a5c22693936b66048.js